import React from 'react';
import ReactDOM from 'react-dom';
import isUndefined from 'lodash/isUndefined';
import Section from 'components/Section';
import FormField from 'components/common/FormField';
import Button from 'components/common/Button';
import FormResult from 'components/FormResult';
import fixedHeight from 'components/common/FixedHeight';

class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    const elements = e.target.elements;
    const data = {
      name: elements.name.value,
      email: elements.email.value,
      subject: elements.subject.value,
      message: elements.message.value
    };

    this.props.onSubmit(data);

    e.preventDefault();
  }

  onBeforeSubmit = this.onBeforeSubmit.bind(this);

  onBeforeSubmit() {
    const elements = ReactDOM.findDOMNode(this).querySelector("form").elements;
    for (let i=0, ii=elements.length; i<ii; i++) {
      if (!elements[i].checkValidity()) {
        window.scrollTo(0, window.pageYOffset + elements[i].getBoundingClientRect().top - 120);
        return;
      }
    }
  }

  renderForm() {
    const { color } = this.props;
    return (
      <form className="container contact-form" onSubmit={this.onSubmit}>
        <p className="ml-auto mr-auto mb-45 text-center wide">
          Feel free to contact us and we’ll get back to you shortly
        </p>
        <div className="row no-gutters">
          <FormField className="col-sm-5 mr-sm-25 mb-45 mb-sm-25" id="name" label="Name" required={true}/>
          <FormField className="col mb-45 mb-sm-25" id="email" label="Email" inputType="email" required={true}/>
        </div>
        <div className="row no-gutters">
          <FormField className="col mb-45 mb-sm-25" id="subject" label="Subject" required={true}/>
        </div>
        <div className="row no-gutters">
          <FormField className="col mb-45 mb-sm-25" multiline={true} id="message" label="Message" rows={10} required={true}/>
        </div>
        <div className="row no-gutters">
          <Button size="lg" className="submit-btn contact-btn ml-sm-auto" style={{background: color}} onClick={this.onBeforeSubmit}>Send</Button>
        </div>
      </form>
    );
  }

  renderConfirm(confirmData) {
    let title, text;
    if (!confirmData.err) {
      title = 'Thanks!';
      text = <span>Your request has been successfully sent.</span>;
    } else {
      title = 'Ooooops';
      text = <span>Something went wrong.<br/>Please try again or email us at <b>{this.props.email}</b></span>;
    }
    return (
      <FormResult title={title} text={text} isSuccess={!confirmData.err} />
    );
  }

  render() {
    const {id, confirm } = this.props;
    let content;
    let sectionTitle = confirm ? '' : "Contact us";

    if (!isUndefined(confirm)) {
      content = this.renderConfirm(confirm);
    } else {
      content = this.renderForm();
    }

    return (
      <Section name={id} title={sectionTitle} isDark={true} isFull={true}>
        <div className="contact-section">
          {content}
        </div>
      </Section>
    );
  }
}

export default fixedHeight(Contact);


// WEBPACK FOOTER //
// ./src/components/Contact.js